
export { WaitAndLoadComponent } from './wait-and-load.component';
